export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M19.204 3.01A2 2 0 0 1 21 5v14l-.01.204a2 2 0 0 1-1.786 1.785L19 21H5l-.204-.01a2 2 0 0 1-1.785-1.786L3 19V5a2 2 0 0 1 1.796-1.99L5 3h14l.204.01ZM4.5 12.5V19a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-6.5h-15Zm.5-8a.5.5 0 0 0-.5.5v6h15V5a.5.5 0 0 0-.5-.5H5Z"/>
</svg>`
